export default {
  "machine-learning": {
    "passage": "{items, plural, =1 {Antwort} other {Antworten}} {current}/{length, number}",
    "passages": "Antworten",
    "passagesCollapsed": "Ich habe {passagesNb, number} mögliche Antworten gefunden",
    "answers": "Vorgeschlagene Antworten",
    "answersCollapsed": "Ich habe {answersNb, number} vorgeschlagene Antworten gefunden",
    "answer": "Vorgeschlagene Antwort"
  }
}